import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  IconButton,
  LinearProgress,
  Typography,
} from "@mui/material";
import { colors } from "common";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { BuildsGallerySearchBar } from "./BuildsGallerySearchBar";
import TuneIcon from "@mui/icons-material/Tune";
import { useRouter } from "next/router";

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      display: "flex",
      paddingRight: theme.spacing(7),
      paddingTop: theme.spacing(3),
      flexDirection: "column",
      [theme.breakpoints.down("md")]: {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
      },
    },
    title: {
      fontWeight: 900,
      fontSize: 40,
      color: colors.primary,
      [theme.breakpoints.down("md")]: {
        fontSize: 35,
      },
    },
  }),
  { index: 999 }
);

const BuildsGalleryHeaderComponent = ({
  isLoading,
  onChangeSearchInput,
  searchInputValue,
  productSearchName,
  searchBuildsGalleryList,
  toggleShowFilter,
  onHandleClearKeyword,
}) => {
  const classes = useStyles();
  const router = useRouter();
  const { query } = router;

  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);

  const hasFilters =
    query.cpu ||
    query.build_tier ||
    query.price_range ||
    query.sort ||
    query.keyword;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>PC Build Gallery</Typography>
      <Typography
        style={{ fontWeight: 500, fontSize: 14, color: colors.grey[800] }}
      >
        Simulan ang next big idea mo-PC na para sa&apos;yo Bossing!
      </Typography>

      <Card style={{ padding: 20, marginTop: 10 }}>
        {windowWidth < 1200 && (
          <IconButton aria-label="settings" onClick={() => toggleShowFilter()}>
            <TuneIcon />
          </IconButton>
        )}
        <BuildsGallerySearchBar
          value={searchInputValue || productSearchName}
          onChangeKeyword={onChangeSearchInput}
          searchBuild={searchBuildsGalleryList}
        />
        <Button
          variant="outlined"
          color="primary"
          sx={{ mt: 2 }}
          onClick={onHandleClearKeyword}
          style={{ display: hasFilters ? "block" : "none" }}
        >
          Clear Filter Fields
        </Button>
      </Card>

      <div>{isLoading && <LinearProgress color="secondary" />}</div>
    </div>
  );
};

const BuildsGalleryHeader = React.memo(BuildsGalleryHeaderComponent);
export default BuildsGalleryHeader;
